<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('businessDatabusManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="businessDatabusManageInfo.conditions" class="flex justify-start">
        <el-form-item>
          <el-form-item>
            <el-input v-model="businessDatabusManageInfo.conditions.businessTypeCd"
              :placeholder="$t('businessDatabusManage.inputBusinessType')" clearable />
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-form-item>
            <el-input v-model="businessDatabusManageInfo.conditions.beanName"
              :placeholder="$t('businessDatabusManage.inputAdapter')" clearable />
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="_queryBusinessDatabusMethod">
            {{ $t('businessDatabusManage.query') }}
          </el-button>
          <el-button size="small" @click="_resetBusinessDatabusMethod">
            {{ $t('businessDatabusManage.reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>Databus</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddBusinessDatabusModal">
          {{ $t('businessDatabusManage.add') }}
        </el-button>
      </div>
      <el-table :data="businessDatabusManageInfo.businessDatabuss" border style="width: 100%">
        <el-table-column prop="databusId" :label="$t('businessDatabusManage.id')" align="center" />
        <el-table-column prop="databusName" :label="$t('businessDatabusManage.name')" align="center" />
        <el-table-column prop="businessTypeCd" :label="$t('businessDatabusManage.businessType')" align="center" />
        <el-table-column prop="beanName" :label="$t('businessDatabusManage.adapter')" align="center" />
        <el-table-column prop="seq" :label="$t('businessDatabusManage.seq')" align="center" />
        <el-table-column prop="state" :label="$t('businessDatabusManage.status')" align="center">
          <template slot-scope="scope">
            {{ scope.row.state === '1001' ? $t('businessDatabusManage.inUse') : $t('businessDatabusManage.disabled') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('businessDatabusManage.operation')" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditBusinessDatabusModel(scope.row)">
              {{ $t('businessDatabusManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteBusinessDatabusModel(scope.row)">
              {{ $t('businessDatabusManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="businessDatabusManageInfo.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>

    <add-business-databus ref="addBusinessDatabus" @refresh="queryBusinessDatabus" />
    <edit-business-databus ref="editBusinessDatabus" @refresh="queryBusinessDatabus" />
    <delete-business-databus ref="deleteBusinessDatabus" @refresh="queryBusinessDatabus" />
  </div>
</template>

<script>
import { listBusinessDatabus } from '@/api/dev/businessDatabusApi'
import AddBusinessDatabus from '@/components/dev/addBusinessDatabus/addBusinessDatabus'
import EditBusinessDatabus from '@/components/dev/editBusinessDatabus/editBusinessDatabus'
import DeleteBusinessDatabus from '@/components/dev/deleteBusinessDatabus/deleteBusinessDatabus'

export default {
  name: 'BusinessDatabusManage',
  components: {
    AddBusinessDatabus,
    EditBusinessDatabus,
    DeleteBusinessDatabus
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      businessDatabusManageInfo: {
        businessDatabuss: [],
        total: 0,
        conditions: {
          businessTypeCd: '',
          beanName: '',
          databusId: ''
        }
      }
    }
  },
  created() {
    this._listBusinessDatabuss(this.currentPage, this.pageSize)
  },
  methods: {
    queryBusinessDatabus() {
      this._listBusinessDatabuss(1, this.pageSize)
    },
    async _listBusinessDatabuss(page, rows) {
      try {
        const params = {
          page,
          row: rows,
          ...this.businessDatabusManageInfo.conditions
        }
        const res = await listBusinessDatabus(params)
        this.businessDatabusManageInfo.businessDatabuss = res.data
        this.businessDatabusManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _openAddBusinessDatabusModal() {
      this.$refs.addBusinessDatabus.open()
    },
    _openEditBusinessDatabusModel(row) {
      this.$refs.editBusinessDatabus.open(row)
    },
    _openDeleteBusinessDatabusModel(row) {
      this.$refs.deleteBusinessDatabus.open(row)
    },
    _queryBusinessDatabusMethod() {
      this.currentPage = 1
      this._listBusinessDatabuss(this.currentPage, this.pageSize)
    },
    _resetBusinessDatabusMethod() {
      this.businessDatabusManageInfo.conditions = {
        businessTypeCd: '',
        beanName: '',
        databusId: ''
      }
      this._listBusinessDatabuss(this.currentPage, this.pageSize)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listBusinessDatabuss(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listBusinessDatabuss(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.el-col {
  width: 100%;
}
</style>